module.exports = __webpack_public_path__ + "static/media/079-printer.a46787e0.svg";